import React, { useEffect, useState } from "react";

import {
  Card,
  Row,
  Col,
  Table,
  InputGroup,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faSearch,
  faFileExcel,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";

import swal from "sweetalert";

import { productService } from "../../../Service/AllSalestoolAPI";

const COMPONENT_COLUMN_TEMPLATE = [
  {
    key: "piItemCodePart",
    label: "PI Part code",
    aliases: ["piItemCodePart", "ptItemCodePart", "itemCodePart", "piItemCode"],
  },
  {
    key: "piDescription",
    label: "PI Component Description ",
    aliases: ["piDescription", "description", "piDesc"],
  },
  {
    key: "vertical",
    label: "Vertical",
    aliases: ["vertical", "verticalName", "productVertical"],
  },
  {
    key: "type",
    label: "Type",
    aliases: ["type", "componentType", "itemType"],
  },
  {
    key: "partCategory",
    label: "Part Category",
    aliases: ["partCategory", "category", "partCategoryName"],
  },
  {
    key: "supplier",
    label: "Supplier",
    aliases: ["supplier", "supplierName", "vendor"],
  },
];

const getCellValue = (row, column) => {
  const matchedKey = column.aliases.find(
    (alias) =>
      Object.prototype.hasOwnProperty.call(row, alias) &&
      row[alias] !== null &&
      row[alias] !== undefined &&
      row[alias] !== ""
  );

  const value = matchedKey ? row[matchedKey] : "-";
  return value ?? "-";
};

const AddComponent = () => {


  const [file, setFile] = useState(null);

  const [fileName, setFileName] = useState("");

  const [columns, setColumns] = useState([]);

  const [rows, setRows] = useState([]);

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");




  // ==============================
  // GET API - LOAD TABLE DATA
  // ==============================

  const fetchComponents = async () => {

    try {

      setLoading(true);
      setError("");

      const response =
        await productService.getUploadedComponents();


      console.log(
        "FULL GET RESPONSE:",
        response
      );


      let apiData = response;


      // if response has data property
      if (response?.data) {
        apiData = response.data;
      }

      if (
        apiData?.headers &&
        apiData?.content
      ) {

        setRows(apiData.content);
        setColumns(COMPONENT_COLUMN_TEMPLATE);

        return;

      }


      if (Array.isArray(apiData)) {


        setRows(apiData);


        if (apiData.length > 0) {

          setColumns(COMPONENT_COLUMN_TEMPLATE);

        }


        return;

      }



      if (typeof apiData === "object") {


        setRows([apiData]);


        setColumns(COMPONENT_COLUMN_TEMPLATE);


        return;

      }

      setRows([]);

      setColumns([]);

    }
    catch (error) {

      console.error(
        "GET COMPONENT ERROR:",
        error.response?.data || error.message
      );


      setError(
        "Unable to fetch components"
      );


    }
    finally {

      setLoading(false);

    }

  };
// Load table when page opens

  useEffect(() => {

    fetchComponents();

  }, []);


  const handleFileChange = async (event) => {
    const inputElement = event.target;
    const selectedFile = inputElement.files[0];
    if (!selectedFile) return;

    const willUpload = await swal({
      title: "Confirm Upload",
      text: `Are you sure you want to upload "${selectedFile.name}"?`,
      icon: "info",
      buttons: ["Cancel", "Yes, Upload"],
    });

    if (willUpload) {
      setFile(selectedFile);
      setFileName(selectedFile.name);

      try {
        setLoading(true);
        await productService.uploadComponentsExcel(selectedFile);
        await swal("Great", "Components uploaded successfully", "success");
        await fetchComponents();
      } catch (error) {
        console.error(error);
        setError("Upload failed");
      } finally {
        setLoading(false);
        inputElement.value = null;
        setFile(null);
        setFileName("");
      }
    } else {
      inputElement.value = null;
    }
  };


  // SEARCH

  const filteredRows =
    rows.filter((row) =>


      Object.values(row)
        .join(" ")
        .toLowerCase()
        .includes(
          search.toLowerCase()
        )


    );

  return (

    <div

      style={{

        height: "100vh",

        padding: "15px",

        overflow: "hidden"

      }}

    >

    <Card

        className="shadow-sm"

        style={{

          height: "100%"

        }}

      >

        <Card.Header

          className="bg-white"

        >

          <Row className="align-items-center">


            <Col md={7}>

              {/* 
              <h4>

                Upload Components

              </h4> */}

              <h5 className="head mb-2 mt-2" style={{ fontSize: '1.1rem' }}>Sales Components</h5>


            </Col>


            <Col

              md={5}

              className="text-end"

            >

          <label className={`btn btn-success me-2 mt-2 ${loading ? 'disabled' : ''}`}>
                {loading ? <Spinner size="sm" className="me-2" /> : <FontAwesomeIcon icon={faUpload} className="me-2" />}
                Upload Excel
                 <input type="file" hidden accept=".xlsx,.xls" onChange={handleFileChange} disabled={loading} />
              </label>


            </Col>


          </Row>


        </Card.Header>

        <Card.Body

          style={{

            overflow: "hidden"

          }}

        >



    {

            error &&


            <div

              className="alert alert-danger"

            >

              {error}

            </div>


          }


          <Row className="mb-3">


            <Col md={4}>


              <InputGroup>


                <InputGroup.Text>

                  <FontAwesomeIcon

                    icon={faSearch}

                  />

                </InputGroup.Text>




                <Form.Control


                  placeholder="Search data..."

                  value={search}

                  onChange={(e) =>

                    setSearch(
                      e.target.value
                    )

                  }


                />


              </InputGroup>


            </Col>


          </Row>

        <div

            style={{

              height: "calc(100vh - 280px)",

              overflow: "auto"

            }}

          >

         <Table
              bordered
              striped
              hover
              className="sales-custom-table"
            >

         <thead>


                <tr>

             
                  {

                    columns.map((col, index) => (


                      <th

                        key={col.key || index}

                        style={{

                          position: "sticky",

                          top: 0,

                          background: "#457756",

                          color: "white",

                          zIndex: 5,

                          whiteSpace: "nowrap"

                        }}

                      >

                        {col.label || col}

                      </th>


                    ))


                  }

                </tr>


              </thead>
   <tbody>


                {

                  filteredRows.length > 0 ?


                    filteredRows.map((row, index) => (


                      <tr key={index}>

                        {

                          columns.map((col, i) => (


                            <td

                              key={col.key || i}

                              style={{

                                whiteSpace: "nowrap"

                              }}

                            >

                              {getCellValue(row, col)}


                            </td>


                          ))


                        }

                      </tr>


                    ))


                    :

                    <tr>


                      <td

                        colSpan={columns.length + 1}

                        className="text-center"

                      >

                        Data loading...

                      </td>


                    </tr>

                }

               </tbody>

            </Table>

          </div>
</Card.Body>

 </Card>

 </div>


  );


};


export default AddComponent;